export default "__VITE_ASSET__Bsg4GTmR__"